import { render, staticRenderFns } from "./PopularityFilters.vue?vue&type=template&id=673159ea&"
import script from "./PopularityFilters.vue?vue&type=script&lang=js&"
export * from "./PopularityFilters.vue?vue&type=script&lang=js&"
import style0 from "./PopularityFilters.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports